import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_select, {
      items: _ctx.items,
      "item-title": "className",
      "item-value": "classId",
      "model-value": _ctx.modelValue,
      "onUpdate:modelValue": _ctx.updateValue,
      variant: "outlined",
      density: "compact",
      "hide-details": "",
      clearable: "",
      color: "primary"
    }, null, 8, ["items", "model-value", "onUpdate:modelValue"])
  ]))
}